module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9InJlZCIgZD0iTTQyNS43NSAwSDY0MHY0ODBINDI1Ljc1eiIvPgogICAgPHBhdGggZmlsbD0iIzAwOWEwMCIgZD0iTTAgMGgyMTIuODh2NDgwSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmYwIiBkPSJNMjEyLjg4IDBoMjEzLjk1djQ4MEgyMTIuODh6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ml.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ml.svg
// module chunks = 0